module.exports = __webpack_public_path__ + "media/newstyle/images/icon-cart-grey-1a9065de212c3cad64cbf7c4e0a1e21a.svg";